/**
 * Was eine Server-Seite (Next.js-Phase 2) vor dem ersten Rendern schon geholt
 * hat — die Rangliste einer Community-Ansicht und das Investorprofil.
 *
 * Bis 25.10.2026 lag beides in den Seitenmodulen selbst
 * (`PublicLeaderboardPage`, `InvestorProfilePage`). `OeffentlicheSeite` musste
 * die Module deshalb fest importieren, um `lege…Vor` zu rufen — und jede
 * öffentliche Seite lud damit die Community-Backtests samt Diagramm-Bibliothek
 * mit (gemessen: rund 100 KB ungenutztes JavaScript auf der Startseite). Hier
 * stehen nur die zwei Speicher; die Seiten lädt `OeffentlicheSeite` je Seite
 * nach.
 */

/**
 * Statistik, Liste und Ranking-Länder für genau eine Ansicht. Der Schlüssel
 * (`ranglistenSchluessel`) nennt alles, wovon die Antwort abhängt; passt er
 * nicht, lädt die Seite wie ohne Vorlage.
 */
const ranglisten = new Map<string, unknown>();

export function legeRanglisteVor(schluessel: string, daten: unknown): void {
  ranglisten.set(schluessel, daten);
}

export function vorgelegteRangliste(schluessel: string): unknown {
  return ranglisten.get(schluessel);
}

/** Profile je Benutzername. */
const profile = new Map<string, unknown>();

export function legeProfilVor(username: string, profil: unknown): void {
  profile.set(username, profil);
}

export function profilVorgelegt(username: string): boolean {
  return profile.has(username);
}

export function vorgelegtesProfil(username: string): unknown {
  return profile.get(username) ?? null;
}
